export const clickableCards = (() => {
   // return false;
    const clickableClasses = [
       // "report",
       // "pressingIssue",
        "notice"
    ]

    clickableClasses.forEach((sel) => makeClickable(sel));

    function makeClickable(selector) {
        let cards = document.querySelectorAll("."+selector);

        //loops through all cards and adds listener for click
        Array.from(cards).forEach((card) => addEL(card));
        function addEL(card) {
            card.classList.add(selector+"-clickable");
            const link = card.querySelector("a");

            //link.addEventListener("focus", function () {
            //    card.classList.add(selector+"-focus");
            //});
            //link.addEventListener("blur", function () {
            //    card.classList.remove(selector+"-focus");
            //});

            card.addEventListener("click", function () {
                if (!link) return;
                const url = link.getAttribute("href");
                location.href = url;
                link.preventDefault; 
            });
        }
    }
})();
